import CustomerRecordWidgetItem from "./CustomerRecordWidgetItem";

class CustomerRecordWidgetItems {
  constructor(private readonly _list: CustomerRecordWidgetItem[] = []) {
  }

  public isEmpty(): boolean {
    return this._list ? this._list.length <= 0 : true;
  }

  public has(index: number): boolean {
    return !!this._list[index];
  }

  public toList(): CustomerRecordWidgetItem[] {
    return this._list;
  }

  public findByIndex(index: number): CustomerRecordWidgetItem {
    if (this.isEmpty() || !this.has(index)) return new CustomerRecordWidgetItem();
    return this._list[index];
  }

  public replace(index: number, widgetItem: CustomerRecordWidgetItem): CustomerRecordWidgetItems {
    if (this.isEmpty() || !this.has(index)) return new CustomerRecordWidgetItems();
    this._list[index] = widgetItem;
    return new CustomerRecordWidgetItems(this._list);
  }

  public add(widgetItem: CustomerRecordWidgetItem): CustomerRecordWidgetItems {
    this._list.push(widgetItem);
    return new CustomerRecordWidgetItems(this._list);
  }

  public delete(index: number): CustomerRecordWidgetItems {
    if (this.isEmpty() || !this.has(index)) return new CustomerRecordWidgetItems(this._list);
    this._list.splice(index, 1);
    return new CustomerRecordWidgetItems(this._list);
  }

  public size(): number {
    return this._list.length;
  }
}

export default CustomerRecordWidgetItems;
